export const AdminMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "people", text: "User", to: "/users" },
      { icon: "account_balance", text: "Warehouse", to: "/warehouses" },
      { icon: "store", text: "Shop", to: "/shops" },
      { icon: "computer", text: "Counter", to: "/counters" },
      { icon: "store", text: "Customer Shop", to: "/customer-shops" },
      { icon: "shop_two", text: "Shop Type", to: "/shop-types" },
      {
        icon: "format_list_numbered",
        text: "System Serialize",
        to: "/system-serializes",
      },
      { icon: "credit_card", text: "Credit Level", to: "/credit-levels" },
      { icon: "account_box", text: "Customer", to: "/customers" },
      { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
      { icon: "location_city", text: "City", to: "/cities" },
      { icon: "border_all", text: "Bin", to: "/bins" },
      { icon: "apps", text: "Bin Type", to: "/bintypes" },
      { icon: "attach_money", text: "Region", to: "/regions" },
      { icon: "attach_money", text: "Price Model", to: "/price-models" },
      { icon: "group", text: "Sale Team", to: "/sale-teams" },
      { icon: "code", text: "Letter Head", to: "/letter-heads" },
      { icon: "business", text: "Branch", to: "/branchs" },
      { icon: "location_city", text: "Country", to: "/countrys" },
    ],
  },

  {
    header: "Tax Management",
    subMenu: [{ icon: "receipt", text: "Tax", to: "/taxs" }],
  },
  {
    header: "Currency Management",
    subMenu: [
      { icon: "shop", text: "Currency List", to: "/currencies" },
      {
        icon: "shop",
        text: "Currency Exchange Rate",
        to: "/currency-exchange-rates",
      },
    ],
  },
  {
    header: "Product Management",
    subMenu: [
      { icon: "loyalty", text: "Brand", to: "/brands" },
      { icon: "widgets", text: "Category", to: "/categories" },
      { icon: "group_work", text: "Category Group", to: "/category-groups" },
      { icon: "ac_unit", text: "Unit", to: "/units" },
      { icon: "group_work", text: "Product Group", to: "/product-groups" },
      { icon: "card_membership", text: "Product", to: "/products" },
    ],
  },

  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      { icon: "list", text: "Procurement Plan", to: "/procurement-plans" },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },

  {
    header: "QC Management",
    subMenu: [{ icon: "spa", text: "QC", to: "/qcs" }],
  },

  {
    header: "Order Management",
    subMenu: [{ icon: "shopping_basket", text: "Order", to: "/orders" }],
  },

  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      {
        icon: "local_shipping",
        text: "Stock Transfer",
        to: "/stock-transfers",
      },
      {
        icon: "near_me",
        text: "Stock Transfer Request",
        to: "/stock-transfer-requests",
      },
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      {
        icon: "picture_in_picture",
        text: "Stock Template",
        to: "/stock-templates",
      },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
      { icon: "receipt", text: "Sale Order", to: "/sale-issue" },
    ],
  },

  {
    header: "Location Management",
    subMenu: [
      {
        icon: "import_export",
        text: "Location Movement",
        to: "/location-movements",
      },
    ],
  },

  {
    header: "Counter Cash Management",
    subMenu: [
      { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
    ],
  },

  {
    header: "Sale",
    subMenu: [
      { icon: "assignment", text: "Sale", to: "/whole-sales" },
      { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
      { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
      { icon: "report", text: "Order Sale Report", to: "/order-sale-report" },
    ],
  },

  {
    header: "Way Management",
    subMenu: [
      { icon: "map", text: "Way", to: "/ways" },
      { icon: "local_shipping", text: "Way Assign", to: "/way-assigns" },
    ],
  },

  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "local_mall", text: "Department", to: "/departments" },
      {
        icon: "attach_money",
        text: "Manufacturing Cost",
        to: "/manufacturing-costs",
      },
      { icon: "extension", text: "Production Item", to: "/production-items" },
      {
        icon: "featured_play_list",
        text: "Production Plan",
        to: "/production-plans",
      },
      {
        icon: "assignment",
        text: "Production Order",
        to: "/production-orders",
      },
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
      {
        icon: "extension",
        text: "Store Return Note",
        to: "/store-return-notes",
      },
      { icon: "poll", text: "Production", to: "/productions" },
      {
        icon: "attach_money",
        text: "Production Costing",
        to: "/production-costings",
      },
      { icon: "report", text: "Production Report", to: "/production-report" },
      //{ icon: "apps", text: "Material Session", to: "/material-sessions" },
      { icon: "report", text: "Production Report By Category", to: "/production-report-by-category" },
    ],
  },

  {
    header: "Asset Management",
    subMenu: [
      {
        icon: "build",
        text: "Maintenance Frequency",
        to: "/maintenance-frequencys",
      },
      { icon: "build", text: "Maintenance Type", to: "/maintenance-types" },
      { icon: "build", text: "Machine Type", to: "/machine-types" },
      {
        icon: "build",
        text: "Check List Frequency",
        to: "/check-list-frequencys",
      },
      { icon: "account_balance_wallet", text: "Asset", to: "/assets" },
      { icon: "build", text: "Machine", to: "/machines" },
      {
        icon: "account_balance_wallet",
        text: "Check List",
        to: "/check-lists",
      },
      {
        icon: "account_balance_wallet",
        text: "Maintenance Schedule",
        to: "/maintenance-schedules",
      },
      {
        icon: "report",
        text: "Preventive Maintenance Machine Report",
        to: "/preventive-maintenance-machine-report",
      },
      {
        icon: "shopping_basket",
        text: "Purchase Order(Asset)",
        to: "/purchase-order-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan(Asset)",
        to: "/procurement-plan-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan Report(Asset)",
        to: "/procurement-plan-asset-report",
      },
      {
        icon: "list",
        text: "Asset Summary Report",
        to: "/asset-summary-report",
      },
      { icon: "list", text: "Asset Detail Report", to: "/asset-detail-report" },
    ],
  },

  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
      {
        icon: "account_balance_wallet",
        text: "Account Receivable",
        to: "/accountreceivables",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Payable",
        to: "/accountpayables",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Head",
        to: "/accountheads",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Type",
        to: "/account-types",
      },
      {
        icon: "account_balance_wallet",
        text: "Chart Of Account",
        to: "/chart-of-accounts",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger",
        to: "/general-ledgers",
      },
      {
        icon: "account_balance_wallet",
        text: "Ledger Entry",
        to: "/general-journals",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger Listing",
        to: "/general-ledger-listing",
      },
      {
        icon: "account_balance_wallet",
        text: "Trial Balance",
        to: "/trial-balances",
      },
      {
        icon: "account_balance_wallet",
        text: "Cash Trial Balance",
        to: "/cash-trial-balance",
      },
      {
        icon: "account_balance_wallet",
        text: "Income Statement",
        to: "/income-statement-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Income Statement",
        to: "/income-statements",
      },
      {
        icon: "account_balance_wallet",
        text: "Income Statement By Branch",
        to: "/income-statement-by-branch",
      },
      {
        icon: "account_balance_wallet",
        text: "Manufacturing Account",
        to: "/manufacturing-account-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Manufacturing Account",
        to: "/manufacturing-accounts",
      },
      {
        icon: "account_balance_wallet",
        text: "Balance Sheet",
        to: "/balance-sheet-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Balance Sheet",
        to: "/balance-sheets",
      },
      {
        icon: "account_balance_wallet",
        text: "Operation Setting",
        to: "/operation-settings",
      },
      {
        icon: "account_balance_wallet",
        text: "Layout Setting",
        to: "/layout-settings",
      },
      {
        icon: "account_balance_wallet",
        text: "Finance Session",
        to: "/finance-sessions",
      },
      {
        icon: "account_balance_wallet",
        text: "Finance Setting",
        to: "/finance-settings",
      },
      { icon: "account_balance_wallet", text: "Budget", to: "/budgets" },
    ],
  },
  {
    header: "Finance Reports",
    subMenu: [
      { icon: "report", text: "Net Sale Report", to: "/net-sale-report" },
      {
        icon: "report",
        text: "Net Purchase Report",
        to: "/net-purchase-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Finance) Report",
        to: "/account-receivable-finance-report",
      },
      {
        icon: "report",
        text: "Account Payable (Finance) Report",
        to: "/account-payable-finance-report",
      },
      { icon: "report", text: "Advanced Report", to: "/advanced-report" },
    ],
  },
  {
    header: "General Reports",
    subMenu: [
      { icon: "report", text: "Retail Sale Report", to: "/sale-report" },
      { icon: "report", text: "Way Sale Report", to: "/way-sale-report" },
      { icon: "report", text: "Consignment Report", to: "/consignments" },
      { icon: "report", text: "Check-in Report", to: "/check-in-report" },
      { icon: "report", text: "Product Sale Report", to: "/menu-report" },
      {
        icon: "report",
        text: "Counter Cash Report",
        to: "/counter-cash-report",
      },

      {
        icon: "report",
        text: "Cash In Hand Report",
        to: "/cash-in-hand-report",
      },
      {
        icon: "report",
        text: "Credit Balance Report",
        to: "/customer-credit-balance",
      },
      {
        icon: "report",
        text: "Customer Credit Balance Report",
        to: "/customer-credit-balance-report",
      },
    ],
  },

  {
    header: "Sale Reports",
    subMenu: [
      { icon: "report", text: "Daily Sale Report", to: "/daily-sale-report" },
      {
        icon: "report",
        text: "Product Sale Report By Customer",
        to: "/sale-report-by-code",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report",
        to: "/customer-product-sale-report",
      },
      {
        icon: "report",
        text: "Daily Product Sale Report",
        to: "/stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report",
        to: "/monthly-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By Customer",
        to: "/monthly-stock-analysis-report-by-customer",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By City",
        to: "/monthly-stock-analysis-report-by-city",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Product",
        to: "/customer-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Category",
        to: "/customer-sale-report-by-category",
      },
      {
        icon: "report",
        text: "Daily Customer Sale Report",
        to: "/customer-sale-report",
      },
      {
        icon: "report",
        text: "Customer Sale Analysis Report",
        to: "/sale-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Customer Sale Report",
        to: "/monthly-customer-sale-report",
      },
      {
        icon: "report",
        text: "Monthly Customer Sale Report By Category Group",
        to: "/monthly-customer-sale-report-by-category-group",
      },
      {
        icon: "report",
        text: "Outstanding Invoice Report",
        to: "/outstanding-invoice-report",
      },
      {
        icon: "report",
        text: "Outstanding Invoice Report By Category Group",
        to: "/outstanding-invoice-report-by-category-group",
      },
      {
        icon: "report",
        text: "Account Receivable Report",
        to: "/cash-receipt-listing-by-date",
      },
      {
        icon: "report",
        text: "Account Receivable Report By Customer",
        to: "/account-receivable-report-by-customer",
      },
      {
        icon: "report",
        text: "Damage Sale (Approved) Report",
        to: "/damage-sale-approved-report",
      },
      {
        icon: "report",
        text: "Damage Sale (Not Approved) Report",
        to: "/damage-sale-not-approved-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Advanced Type) Report",
        to: "/account-receivable-advanced-type-report",
      },
      {
        icon: "report",
        text: "Sale Report By Category",
        to: "/sale-report-by-category",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report By Category Group",
        to: "/customer-product-sale-report-by-category-group",
      },
      {
        icon: "report",
        text: "Daily Customer Sale Report By Category Group",
        to: "/daily-customer-sale-report-by-category-group",
      },
      {
        icon: "report",
        text: "Customer Sale Analysis Report By Category Group",
        to: "/customer-sale-analysis-report-by-category-group",
      },
      {
        icon: "report",
        text: "Damage Sale (Approved) Report By Category Group",
        to: "/damage-sale-approved-report-by-category-group",
      },
      {
        icon: "report",
        text: "Damage Sale (Not Approved) Report By Category Group",
        to: "/damage-sale-not-approved-report-by-category-group",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Sale Team",
        to: "/customer-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report by Sale Team",
        to: "/customer-product-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Product Sale Report by Sale Team",
        to: "/product-sale-report-by-sale-team",
      },
    ],
  },

  {
    header: "Purchase Reports",
    subMenu: [
      {
        icon: "report",
        text: "Purchase Income Stock Report",
        to: "/po-stock-report",
      },
      {
        icon: "report",
        text: "Account Payable Report",
        to: "/account-payable-report",
      },
      {
        icon: "report",
        text: "Account Payable Report By Supplier",
        to: "/account-payable-report-by-supplier",
      },
      {
        icon: "report",
        text: "Stock Valuation Report",
        to: "/stock-valuation-report",
      },
      { icon: "report", text: "Stock Balance Report", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary Report",
        to: "/stock-balance-summary",
      },
      {
        icon: "report",
        text: "Stock Transfer Report",
        to: "/stock-transfer-report",
      },
      {
        icon: "report",
        text: "Purchase Order Report",
        to: "/purchase-order-report",
      },
      {
        icon: "report",
        text: "Purchase Analysis Report by Supplier",
        to: "/purchase-analysis-report",
      },
    ],
  },
];

export const WarehouseManagerMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },
  {
    header: "QC Management",
    subMenu: [{ icon: "spa", text: "QC", to: "/qcs" }],
  },
  {
    header: "Order Management",
    subMenu: [{ icon: "shopping_basket", text: "Order", to: "/orders" }],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      {
        icon: "local_shipping",
        text: "Stock Transfer",
        to: "/stock-transfers",
      },
      {
        icon: "near_me",
        text: "Stock Transfer Request",
        to: "/stock-transfer-requests",
      },
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary",
        to: "/stock-balance-summary",
      },
      {
        icon: "picture_in_picture",
        text: "Stock Template",
        to: "/stock-templates",
      },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      {
        icon: "report",
        text: "Stock Valuation Report",
        to: "/stock-valuation-report",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
      { icon: "receipt", text: "Sale Order", to: "/sale-issue" },
    ],
  },
  {
    header: "Location Management",
    subMenu: [
      {
        icon: "import_export",
        text: "Location Movement",
        to: "/location-movements",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      {
        icon: "assignment",
        text: "Production Order",
        to: "/production-orders",
      },
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
      {
        icon: "extension",
        text: "Store Return Note",
        to: "/store-return-notes",
      },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
    ],
  },
];

export const WarehouseStaffMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },
  {
    header: "QC Management",
    subMenu: [{ icon: "spa", text: "QC", to: "/qcs" }],
  },
  {
    header: "Order Management",
    subMenu: [{ icon: "shopping_basket", text: "Order", to: "/orders" }],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      {
        icon: "local_shipping",
        text: "Stock Transfer",
        to: "/stock-transfers",
      },
      {
        icon: "near_me",
        text: "Stock Transfer Request",
        to: "/stock-transfer-requests",
      },
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary",
        to: "/stock-balance-summary",
      },
      {
        icon: "picture_in_picture",
        text: "Stock Template",
        to: "/stock-templates",
      },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
      { icon: "receipt", text: "Sale Order", to: "/sale-issue" },
    ],
  },
  {
    header: "Location Management",
    subMenu: [
      {
        icon: "import_export",
        text: "Location Movement",
        to: "/location-movements",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      {
        icon: "assignment",
        text: "Production Order",
        to: "/production-orders",
      },
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
      {
        icon: "extension",
        text: "Store Return Note",
        to: "/store-return-notes",
      },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
    ],
  },
];
export const SaleManagerMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "store", text: "Shop", to: "/shops" },
      { icon: "computer", text: "Counter", to: "/counters" },
      { icon: "account_box", text: "Customer", to: "/customers" },
      { icon: "store", text: "Customer Shop", to: "/customer-shops" },
      { icon: "shop_two", text: "Shop Type", to: "/shop-types" },
      { icon: "attach_money", text: "Price Model", to: "/price-models" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
    ],
  },
  {
    header: "Order Management",
    subMenu: [{ icon: "shopping_basket", text: "Order", to: "/orders" }],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      // { icon: "photo_library", text: "Stock In", to: "/stockins" },
      { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary Report",
        to: "/stock-balance-summary",
      },
    ],
  },
  {
    header: "User Management",
    subMenu: [
      { icon: "assignment", text: "Shift Info Setup", to: "/shift-infos" },
      { icon: "assignment_ind", text: "Shift Assign", to: "/shift-assigns" },
    ],
  },
  {
    header: "Counter Cash Management",
    subMenu: [
      { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
    ],
  },
  {
    header: "Way Management",
    subMenu: [
      { icon: "map", text: "Way", to: "/ways" },
      { icon: "local_shipping", text: "Way Assign", to: "/way-assigns" },
    ],
  },
  {
    header: "Sale",
    subMenu: [
      { icon: "attach_money", text: "Price Model", to: "/price-models" },
      { icon: "assignment", text: "Sale", to: "/whole-sales" },
      { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
      { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
      { icon: "report", text: "Order Sale Report", to: "/order-sale-report" },
      { icon: "report", text: "Stock Balance Report", to: "/stock-balances" },
      {
        icon: "report",
        text: "Outstanding Invoice Report",
        to: "/outstanding-invoice-report",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
    ],
  },
  {
    header: "General Reports",
    subMenu: [
      { icon: "report", text: "Way Sale Report", to: "/way-sale-report" },
      { icon: "report", text: "Check-in Report", to: "/check-in-report" },
      { icon: "report", text: "Product Sale Report", to: "/menu-report" },
      {
        icon: "report",
        text: "Counter Cash Report",
        to: "/counter-cash-report",
      },
      //{ icon: "report", text: "Cash In Hand Report", to: "/cash-in-hand-report" },
    ],
  },
  {
    header: "Sale Reports",
    subMenu: [
      {
        icon: "report",
        text: "Product Sale Report By Customer",
        to: "/sale-report-by-code",
      },
    ],
  },
];

export const GeneralManagerMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "store", text: "Shop", to: "/shops" },
      { icon: "computer", text: "Counter", to: "/counters" },
      { icon: "store", text: "Customer Shop", to: "/customer-shops" },
      { icon: "shop_two", text: "Shop Type", to: "/shop-types" },
      { icon: "account_box", text: "Customer", to: "/customers" },
      { icon: "group", text: "Sale Team", to: "/sale-teams" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },
  {
    header: "Order Management",
    subMenu: [{ icon: "shopping_basket", text: "Order", to: "/orders" }],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary",
        to: "/stock-balance-summary",
      },
    ],
  },
  {
    header: "User Management",
    subMenu: [
      { icon: "assignment", text: "Shift Info Setup", to: "/shift-infos" },
      { icon: "assignment_ind", text: "Shift Assign", to: "/shift-assigns" },
    ],
  },
  {
    header: "Counter Cash Management",
    subMenu: [
      { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
    ],
  },
  {
    header: "Way Management",
    subMenu: [
      { icon: "map", text: "Way", to: "/ways" },
      { icon: "local_shipping", text: "Way Assign", to: "/way-assigns" },
    ],
  },
  {
    header: "Sale",
    subMenu: [
      { icon: "attach_money", text: "Price Model", to: "/price-models" },
      { icon: "assignment", text: "Sale", to: "/whole-sales" },
      { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
      { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
      { icon: "report", text: "Stock Balance Report", to: "/stock-balances" },
      {
        icon: "report",
        text: "Outstanding Invoice Report",
        to: "/outstanding-invoice-report",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
    ],
  },
  {
    header: "General Reports",
    subMenu: [
      { icon: "report", text: "Retail Sale Report", to: "/sale-report" },
      { icon: "report", text: "Way Sale Report", to: "/way-sale-report" },
      { icon: "report", text: "Check-in Report", to: "/check-in-report" },
      { icon: "report", text: "Product Sale Report", to: "/menu-report" },
      {
        icon: "report",
        text: "Counter Cash Report",
        to: "/counter-cash-report",
      },
      {
        icon: "report",
        text: "Cash In Hand Report",
        to: "/cash-in-hand-report",
      },
    ],
  },
  {
    header: "Sale Reports",
    subMenu: [
      {
        icon: "report",
        text: "Customer Sale Analysis Report",
        to: "/sale-analysis-report",
      },
      {
        icon: "report",
        text: "Daily Product Sale Report",
        to: "/stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report",
        to: "/monthly-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Product",
        to: "/customer-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By City",
        to: "/monthly-stock-analysis-report-by-city",
      },
      {
        icon: "report",
        text: "Product Sale Report By Customer",
        to: "/sale-report-by-code",
      },
      {
        icon: "report",
        text: "Monthly Customer Sale Report",
        to: "/monthly-customer-sale-report",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Sale Team",
        to: "/customer-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report by Sale Team",
        to: "/customer-product-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Product Sale Report by Sale Team",
        to: "/product-sale-report-by-sale-team",
      },
    ],
  },
];

export const SaleMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "local_grocery_store", text: "Retail Sale", to: "/sales" },
      { icon: "shopping_basket", text: "Order", to: "/orders" },
    ],
  },
];

export const TopManagementMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
    ],
  },
  {
    header: "Product Management",
    subMenu: [
      { icon: "loyalty", text: "Brand", to: "/brands" },
      { icon: "widgets", text: "Category", to: "/categories" },
      { icon: "ac_unit", text: "Unit", to: "/units" },
      { icon: "group_work", text: "Product Group", to: "/product-groups" },
      { icon: "card_membership", text: "Product", to: "/products" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
      { icon: "poll", text: "Production", to: "/productions" },
      { icon: "poll", text: "Production Costing", to: "/production-costings" },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      {
        icon: "account_balance_wallet",
        text: "Manufacturing Account",
        to: "/manufacturing-account-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Manufacturing Account",
        to: "/manufacturing-accounts",
      },
    ],
  },
  {
    header: "General Reports",
    subMenu: [
      { icon: "report", text: "Retail Sale Report", to: "/sale-report" },
      { icon: "report", text: "Product Sale Report", to: "/menu-report" },
      {
        icon: "report",
        text: "Counter Cash Report",
        to: "/counter-cash-report",
      },
      {
        icon: "report",
        text: "Cash In Hand Report",
        to: "/cash-in-hand-report",
      },
      {
        icon: "account_balance_wallet",
        text: "Manufacturing Account",
        to: "/manufacturing-account-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Manufacturing Account",
        to: "/manufacturing-accounts",
      },
    ],
  },
];

export const FinanceManagerMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "account_box", text: "Customer", to: "/customers" },
      { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
      { icon: "attach_money", text: "Price Model", to: "/price-models" },
    ],
  },
  {
    header: "Product Management",
    subMenu: [
      { icon: "loyalty", text: "Brand", to: "/brands" },
      { icon: "widgets", text: "Category", to: "/categories" },
      { icon: "ac_unit", text: "Unit", to: "/units" },
      { icon: "group_work", text: "Product Group", to: "/product-groups" },
      { icon: "card_membership", text: "Product", to: "/products" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      { icon: "list", text: "Procurement Plan", to: "/procurement-plans" },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
    ],
  },
  {
    header: "Sale",
    subMenu: [
      { icon: "assignment", text: "Sale", to: "/whole-sales" },
      { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
    ],
  },
  {
    header: "Asset Management",
    subMenu: [
      { icon: "list", text: "Asset Detail Report", to: "/asset-detail-report" },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
      {
        icon: "account_balance_wallet",
        text: "Account Receivable",
        to: "/accountreceivables",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Payable",
        to: "/accountpayables",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Head",
        to: "/accountheads",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Type",
        to: "/account-types",
      },
      {
        icon: "account_balance_wallet",
        text: "Chart Of Account",
        to: "/chart-of-accounts",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger",
        to: "/general-ledgers",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger Listing",
        to: "/general-ledger-listing",
      },
      {
        icon: "account_balance_wallet",
        text: "Ledger Entry",
        to: "/general-journals",
      },
      {
        icon: "account_balance_wallet",
        text: "Operation Setting",
        to: "/operation-settings",
      },
      {
        icon: "account_balance_wallet",
        text: "Layout Setting",
        to: "/layout-settings",
      },
      {
        icon: "account_balance_wallet",
        text: "Finance Session",
        to: "/finance-sessions",
      },
      {
        icon: "account_balance_wallet",
        text: "Finance Setting",
        to: "/finance-settings",
      },
    ],
  },
  {
    header: "Finance Reports",
    subMenu: [
      { icon: "report", text: "Net Sale Report", to: "/net-sale-report" },
      {
        icon: "report",
        text: "Net Purchase Report",
        to: "/net-purchase-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Finance) Report",
        to: "/account-receivable-finance-report",
      },
      {
        icon: "report",
        text: "Account Payable (Finance) Report",
        to: "/account-payable-finance-report",
      },
      { icon: "report", text: "Advanced Report", to: "/advanced-report" },
    ],
  },
  {
    header: "General Reports",
    subMenu: [
      { icon: "report", text: "Retail Sale Report", to: "/sale-report" },
      { icon: "report", text: "Way Sale Report", to: "/way-sale-report" },
      { icon: "report", text: "Consignment Report", to: "/consignments" },
      { icon: "report", text: "Check-in Report", to: "/check-in-report" },
      { icon: "report", text: "Product Sale Report", to: "/menu-report" },
      {
        icon: "report",
        text: "Counter Cash Report",
        to: "/counter-cash-report",
      },
      {
        icon: "report",
        text: "Cash In Hand Report",
        to: "/cash-in-hand-report",
      },
      {
        icon: "report",
        text: "Credit Balance Report",
        to: "/customer-credit-balance",
      },
      {
        icon: "report",
        text: "Customer Credit Balance Report",
        to: "/customer-credit-balance-report",
      },
    ],
  },

  {
    header: "Sale Reports",
    subMenu: [
      { icon: "report", text: "Daily Sale Report", to: "/daily-sale-report" },
      {
        icon: "report",
        text: "Product Sale Report By Customer",
        to: "/sale-report-by-code",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report",
        to: "/customer-product-sale-report",
      },
      {
        icon: "report",
        text: "Daily Product Sale Report",
        to: "/stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report",
        to: "/monthly-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By Customer",
        to: "/monthly-stock-analysis-report-by-customer",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By City",
        to: "/monthly-stock-analysis-report-by-city",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Product",
        to: "/customer-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Category",
        to: "/customer-sale-report-by-category",
      },
      {
        icon: "report",
        text: "Daily Customer Sale Report",
        to: "/customer-sale-report",
      },
      {
        icon: "report",
        text: "Customer Sale Analysis Report",
        to: "/sale-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Customer Sale Report",
        to: "/monthly-customer-sale-report",
      },
      {
        icon: "report",
        text: "Outstanding Invoice Report",
        to: "/outstanding-invoice-report",
      },
      {
        icon: "report",
        text: "Account Receivable Report",
        to: "/cash-receipt-listing-by-date",
      },
      {
        icon: "report",
        text: "Account Receivable Report By Customer",
        to: "/account-receivable-report-by-customer",
      },
      {
        icon: "report",
        text: "Damage Sale (Approved) Report",
        to: "/damage-sale-approved-report",
      },
      {
        icon: "report",
        text: "Damage Sale (Not Approved) Report",
        to: "/damage-sale-not-approved-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Advanced Type) Report",
        to: "/account-receivable-advanced-type-report",
      },
      {
        icon: "report",
        text: "Damage Sale (Approved) Report By Category Group",
        to: "/damage-sale-approved-report-by-category-group",
      },
      {
        icon: "report",
        text: "Damage Sale (Not Approved) Report By Category Group",
        to: "/damage-sale-not-approved-report-by-category-group",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Sale Team",
        to: "/customer-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report by Sale Team",
        to: "/customer-product-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Product Sale Report by Sale Team",
        to: "/product-sale-report-by-sale-team",
      },
    ],
  },

  {
    header: "Purchase Reports",
    subMenu: [
      {
        icon: "report",
        text: "Purchase Income Stock Report",
        to: "/po-stock-report",
      },
      {
        icon: "report",
        text: "Account Payable Report",
        to: "/account-payable-report",
      },
      {
        icon: "report",
        text: "Account Payable Report By Supplier",
        to: "/account-payable-report-by-supplier",
      },
      {
        icon: "report",
        text: "Stock Valuation Report",
        to: "/stock-valuation-report",
      },
      { icon: "report", text: "Stock Balance Report", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary Report",
        to: "/stock-balance-summary",
      },
      {
        icon: "report",
        text: "Stock Transfer Report",
        to: "/stock-transfer-report",
      },
      {
        icon: "report",
        text: "Purchase Order Report",
        to: "/purchase-order-report",
      },
      {
        icon: "report",
        text: "Purchase Analysis Report by Supplier",
        to: "/purchase-analysis-report",
      },
    ],
  },
];

export const AccountantMenus = [
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
    ],
  },
  {
    header: "Finance",
    subMenu: [
      {
        icon: "account_balance_wallet",
        text: "General Ledger",
        to: "/general-ledgers",
      },
      {
        icon: "account_balance_wallet",
        text: "Ledger Entry",
        to: "/general-journals",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger Listing",
        to: "/general-ledger-listing",
      },
      {
        icon: "account_balance_wallet",
        text: "Trial Balance",
        to: "/trial-balances",
      },
      {
        icon: "account_balance_wallet",
        text: "Cash Trial Balance",
        to: "/cash-trial-balance",
      },
      {
        icon: "account_balance_wallet",
        text: "Income Statement",
        to: "/income-statement-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Income Statement",
        to: "/income-statements",
      },
      {
        icon: "account_balance_wallet",
        text: "Income Statement By Branch",
        to: "/income-statement-by-branch",
      },
      {
        icon: "account_balance_wallet",
        text: "Balance Sheet",
        to: "/balance-sheet-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Balance Sheet",
        to: "/balance-sheets",
      },
    ],
  },
  {
    header: "Finance Reports",
    subMenu: [
      { icon: "report", text: "Net Sale Report", to: "/net-sale-report" },
      {
        icon: "report",
        text: "Net Purchase Report",
        to: "/net-purchase-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Finance) Report",
        to: "/account-receivable-finance-report",
      },
      {
        icon: "report",
        text: "Account Payable (Finance) Report",
        to: "/account-payable-finance-report",
      },
      { icon: "report", text: "Advanced Report", to: "/advanced-report" },
    ],
  },
];

export const ProcurementManagerMenus = [
  {
    header: "General",
    subMenu: [{ icon: "assignment_ind", text: "Supplier", to: "/suppliers" }],
  },
  {
    header: "Product Management",
    subMenu: [
      { icon: "loyalty", text: "Brand", to: "/brands" },
      { icon: "widgets", text: "Category", to: "/categories" },
      { icon: "group_work", text: "Category Group", to: "/category-groups" },
      { icon: "ac_unit", text: "Unit", to: "/units" },
      { icon: "group_work", text: "Product Group", to: "/product-groups" },
      { icon: "card_membership", text: "Product", to: "/products" },
    ],
  },
  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      { icon: "list", text: "Procurement Plan", to: "/procurement-plans" },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      { icon: "assessment", text: "Stock Balance", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary",
        to: "/stock-balance-summary",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
    ],
  },
  {
    header: "Asset Management",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order(Asset)",
        to: "/purchase-order-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan(Asset)",
        to: "/procurement-plan-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan Report(Asset)",
        to: "/procurement-plan-asset-report",
      },
    ],
  },
  {
    header: "Purchase Reports",
    subMenu: [
      {
        icon: "report",
        text: "Account Payable Report By Supplier",
        to: "/account-payable-report-by-supplier",
      },
      {
        icon: "report",
        text: "Purchase Analysis Report by Supplier",
        to: "/purchase-analysis-report",
      },
    ],
  },
  {
    header: "Sale",
    subMenu: [
      { icon: "report", text: "Order Sale Report", to: "/order-sale-report" },
    ],
  },
];

export const ProductionManagerMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "account_balance", text: "Warehouse", to: "/warehouses" },
      { icon: "store", text: "Shop", to: "/shops" },
      { icon: "border_all", text: "Bin", to: "/bins" },
      { icon: "apps", text: "Bin Type", to: "/bintypes" },
    ],
  },
  {
    header: "Product Management",
    subMenu: [
      { icon: "loyalty", text: "Brand", to: "/brands" },
      { icon: "widgets", text: "Category", to: "/categories" },
      { icon: "group_work", text: "Category Group", to: "/category-groups" },
      { icon: "ac_unit", text: "Unit", to: "/units" },
      { icon: "group_work", text: "Product Group", to: "/product-groups" },
      { icon: "card_membership", text: "Product", to: "/products" },
    ],
  },
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      {
        icon: "picture_in_picture",
        text: "Stock Template",
        to: "/stock-templates",
      },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
      { icon: "receipt", text: "Sale Order", to: "/sale-issue" },
    ],
  },
  {
    header: "Location Management",
    subMenu: [
      {
        icon: "import_export",
        text: "Location Movement",
        to: "/location-movements",
      },
    ],
  },
  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "local_mall", text: "Department", to: "/departments" },
      {
        icon: "attach_money",
        text: "Manufacturing Cost",
        to: "/manufacturing-costs",
      },
      { icon: "extension", text: "Production Item", to: "/production-items" },
      {
        icon: "featured_play_list",
        text: "Production Plan",
        to: "/production-plans",
      },
      {
        icon: "assignment",
        text: "Production Order",
        to: "/production-orders",
      },
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
      {
        icon: "extension",
        text: "Store Return Note",
        to: "/store-return-notes",
      },
      { icon: "poll", text: "Production", to: "/productions" },
      { icon: "poll", text: "Production Costing", to: "/production-costings" },
      { icon: "report", text: "Production Report", to: "/production-report" },
      //{ icon: "apps", text: "Material Session", to: "/material-sessions" },
      { icon: "report", text: "Production Report By Category", to: "/production-report-by-category" },
    ],
  },
  {
    header: "Purchase Reports",
    subMenu: [
      { icon: "report", text: "Stock Balance Report", to: "/stock-balances" },
    ],
  },
];

export const BranchAdminMenus = [
  {
    header: "General",
    subMenu: [
      { icon: "home", text: "Home", to: "/dashboard" },
      { icon: "account_balance", text: "Warehouse", to: "/warehouses" },
      { icon: "store", text: "Shop", to: "/shops" },
      { icon: "computer", text: "Counter", to: "/counters" },
      { icon: "store", text: "Customer Shop", to: "/customer-shops" },
      { icon: "shop_two", text: "Shop Type", to: "/shop-types" },
      { icon: "credit_card", text: "Credit Level", to: "/credit-levels" },
      { icon: "account_box", text: "Customer", to: "/customers" },
      { icon: "assignment_ind", text: "Supplier", to: "/suppliers" },
      { icon: "location_city", text: "City", to: "/cities" },
      { icon: "border_all", text: "Bin", to: "/bins" },
      { icon: "apps", text: "Bin Type", to: "/bintypes" },
      { icon: "attach_money", text: "Region", to: "/regions" },
      { icon: "attach_money", text: "Price Model", to: "/price-models" },
      { icon: "group", text: "Sale Team", to: "/sale-teams" },
      { icon: "code", text: "Letter Head", to: "/letter-heads" },
      { icon: "business", text: "Branch", to: "/branchs" },
    ],
  },

  {
    header: "Tax Management",
    subMenu: [{ icon: "receipt", text: "Tax", to: "/taxs" }],
  },
  {
    header: "Currency Management",
    subMenu: [
      { icon: "shop", text: "Currency List", to: "/currencies" },
      {
        icon: "shop",
        text: "Currency Exchange Rate",
        to: "/currency-exchange-rates",
      },
    ],
  },
  {
    header: "Product Management",
    subMenu: [
      { icon: "loyalty", text: "Brand", to: "/brands" },
      { icon: "widgets", text: "Category", to: "/categories" },
      { icon: "group_work", text: "Category Group", to: "/category-groups" },
      { icon: "ac_unit", text: "Unit", to: "/units" },
      { icon: "group_work", text: "Product Group", to: "/product-groups" },
      { icon: "card_membership", text: "Product", to: "/products" },
    ],
  },

  {
    header: "Purchasing",
    subMenu: [
      {
        icon: "shopping_basket",
        text: "Purchase Order",
        to: "/purchase-order",
      },
      { icon: "list", text: "Procurement Plan", to: "/procurement-plans" },
      {
        icon: "list",
        text: "Procurement Plan Report",
        to: "/procurement-plan-report",
      },
    ],
  },

  {
    header: "QC Management",
    subMenu: [{ icon: "spa", text: "QC", to: "/qcs" }],
  },

  {
    header: "Order Management",
    subMenu: [{ icon: "shopping_basket", text: "Order", to: "/orders" }],
  },

  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      {
        icon: "local_shipping",
        text: "Stock Transfer",
        to: "/stock-transfers",
      },
      {
        icon: "near_me",
        text: "Stock Transfer Request",
        to: "/stock-transfer-requests",
      },
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      {
        icon: "picture_in_picture",
        text: "Stock Template",
        to: "/stock-templates",
      },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
      { icon: "receipt", text: "Sale Order", to: "/sale-issue" },
    ],
  },

  {
    header: "Location Management",
    subMenu: [
      {
        icon: "import_export",
        text: "Location Movement",
        to: "/location-movements",
      },
    ],
  },

  {
    header: "Counter Cash Management",
    subMenu: [
      { icon: "credit_card", text: "Counter Cash", to: "/counter-cashs" },
    ],
  },

  {
    header: "Sale",
    subMenu: [
      { icon: "assignment", text: "Sale", to: "/whole-sales" },
      { icon: "assignment_return", text: "Sale Return", to: "/sale-return" },
      { icon: "report", text: "Credit Cash Flow", to: "/credit-cash-flows" },
      { icon: "report", text: "Order Sale Report", to: "/order-sale-report" },
    ],
  },

  {
    header: "Way Management",
    subMenu: [
      { icon: "map", text: "Way", to: "/ways" },
      { icon: "local_shipping", text: "Way Assign", to: "/way-assigns" },
    ],
  },

  {
    header: "Manufacturing Management",
    subMenu: [
      { icon: "local_mall", text: "Department", to: "/departments" },
      {
        icon: "attach_money",
        text: "Manufacturing Cost",
        to: "/manufacturing-costs",
      },
      { icon: "extension", text: "Production Item", to: "/production-items" },
      {
        icon: "featured_play_list",
        text: "Production Plan",
        to: "/production-plans",
      },
      {
        icon: "assignment",
        text: "Production Order",
        to: "/production-orders",
      },
      { icon: "extension", text: "EMR", to: "/emrs" },
      { icon: "extension", text: "RMR", to: "/rmrs" },
      {
        icon: "extension",
        text: "Store Return Note",
        to: "/store-return-notes",
      },
      { icon: "poll", text: "Production", to: "/productions" },
      { icon: "poll", text: "Production Costing", to: "/production-costings" },
      { icon: "report", text: "Production Report", to: "/production-report" },
      //{ icon: "apps", text: "Material Session", to: "/material-sessions" },
      { icon: "report", text: "Production Report By Category", to: "/production-report-by-category" },
    ],
  },

  {
    header: "Asset Management",
    subMenu: [
      {
        icon: "build",
        text: "Maintenance Frequency",
        to: "/maintenance-frequencys",
      },
      { icon: "build", text: "Maintenance Type", to: "/maintenance-types" },
      { icon: "build", text: "Machine Type", to: "/machine-types" },
      {
        icon: "build",
        text: "Check List Frequency",
        to: "/check-list-frequencys",
      },
      { icon: "account_balance_wallet", text: "Asset", to: "/assets" },
      { icon: "build", text: "Machine", to: "/machines" },
      {
        icon: "account_balance_wallet",
        text: "Check List",
        to: "/check-lists",
      },
      {
        icon: "account_balance_wallet",
        text: "Maintenance Schedule",
        to: "/maintenance-schedules",
      },
      {
        icon: "report",
        text: "Preventive Maintenance Machine Report",
        to: "/preventive-maintenance-machine-report",
      },
      {
        icon: "shopping_basket",
        text: "Purchase Order(Asset)",
        to: "/purchase-order-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan(Asset)",
        to: "/procurement-plan-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan Report(Asset)",
        to: "/procurement-plan-asset-report",
      },
      {
        icon: "list",
        text: "Asset Summary Report",
        to: "/asset-summary-report",
      },
      { icon: "list", text: "Asset Detail Report", to: "/asset-detail-report" },
    ],
  },

  {
    header: "Finance",
    subMenu: [
      { icon: "account_balance_wallet", text: "Invoice", to: "/damages" },
      {
        icon: "account_balance_wallet",
        text: "Account Receivable",
        to: "/accountreceivables",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Payable",
        to: "/accountpayables",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Head",
        to: "/accountheads",
      },
      {
        icon: "account_balance_wallet",
        text: "Account Type",
        to: "/account-types",
      },
      {
        icon: "account_balance_wallet",
        text: "Chart Of Account",
        to: "/chart-of-accounts",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger",
        to: "/general-ledgers",
      },
      {
        icon: "account_balance_wallet",
        text: "Ledger Entry",
        to: "/general-journals",
      },
      {
        icon: "account_balance_wallet",
        text: "General Ledger Listing",
        to: "/general-ledger-listing",
      },
      {
        icon: "account_balance_wallet",
        text: "Trial Balance",
        to: "/trial-balances",
      },
      {
        icon: "account_balance_wallet",
        text: "Cash Trial Balance",
        to: "/cash-trial-balance",
      },
      {
        icon: "account_balance_wallet",
        text: "Income Statement",
        to: "/income-statement-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Income Statement",
        to: "/income-statements",
      },
      {
        icon: "account_balance_wallet",
        text: "Income Statement By Branch",
        to: "/income-statement-by-branch",
      },
      {
        icon: "account_balance_wallet",
        text: "Balance Sheet",
        to: "/balance-sheet-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Balance Sheet",
        to: "/balance-sheets",
      },
      {
        icon: "account_balance_wallet",
        text: "Manufacturing Account",
        to: "/manufacturing-account-preview",
      },
      {
        icon: "account_balance_wallet",
        text: "Monthly Manufacturing Account",
        to: "/manufacturing-accounts",
      },
      {
        icon: "account_balance_wallet",
        text: "Operation Setting",
        to: "/operation-settings",
      },
      {
        icon: "account_balance_wallet",
        text: "Layout Setting",
        to: "/layout-settings",
      },
      {
        icon: "account_balance_wallet",
        text: "Finance Session",
        to: "/finance-sessions",
      },
      {
        icon: "account_balance_wallet",
        text: "Finance Setting",
        to: "/finance-settings",
      },
      { icon: "account_balance_wallet", text: "Budget", to: "/budgets" },
    ],
  },
  {
    header: "Finance Reports",
    subMenu: [
      { icon: "report", text: "Net Sale Report", to: "/net-sale-report" },
      {
        icon: "report",
        text: "Net Purchase Report",
        to: "/net-purchase-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Finance) Report",
        to: "/account-receivable-finance-report",
      },
      {
        icon: "report",
        text: "Account Payable (Finance) Report",
        to: "/account-payable-finance-report",
      },
      { icon: "report", text: "Advanced Report", to: "/advanced-report" },
    ],
  },
  {
    header: "General Reports",
    subMenu: [
      { icon: "report", text: "Retail Sale Report", to: "/sale-report" },
      { icon: "report", text: "Way Sale Report", to: "/way-sale-report" },
      { icon: "report", text: "Consignment Report", to: "/consignments" },
      { icon: "report", text: "Check-in Report", to: "/check-in-report" },
      { icon: "report", text: "Product Sale Report", to: "/menu-report" },
      {
        icon: "report",
        text: "Counter Cash Report",
        to: "/counter-cash-report",
      },
      {
        icon: "report",
        text: "Cash In Hand Report",
        to: "/cash-in-hand-report",
      },
      {
        icon: "report",
        text: "Credit Balance Report",
        to: "/customer-credit-balance",
      },
      {
        icon: "report",
        text: "Customer Credit Balance Report",
        to: "/customer-credit-balance-report",
      },
    ],
  },

  {
    header: "Sale Reports",
    subMenu: [
      { icon: "report", text: "Daily Sale Report", to: "/daily-sale-report" },
      {
        icon: "report",
        text: "Product Sale Report By Customer",
        to: "/sale-report-by-code",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report",
        to: "/customer-product-sale-report",
      },
      {
        icon: "report",
        text: "Daily Product Sale Report",
        to: "/stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report",
        to: "/monthly-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By Customer",
        to: "/monthly-stock-analysis-report-by-customer",
      },
      {
        icon: "report",
        text: "Monthly Product Sale Report By City",
        to: "/monthly-stock-analysis-report-by-city",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Product",
        to: "/customer-stock-analysis-report",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Category",
        to: "/customer-sale-report-by-category",
      },
      {
        icon: "report",
        text: "Daily Customer Sale Report",
        to: "/customer-sale-report",
      },
      {
        icon: "report",
        text: "Customer Sale Analysis Report",
        to: "/sale-analysis-report",
      },
      {
        icon: "report",
        text: "Monthly Customer Sale Report",
        to: "/monthly-customer-sale-report",
      },
      {
        icon: "report",
        text: "Monthly Customer Sale Report By Category Group",
        to: "/monthly-customer-sale-report-by-category-group",
      },
      {
        icon: "report",
        text: "Outstanding Invoice Report",
        to: "/outstanding-invoice-report",
      },
      {
        icon: "report",
        text: "Outstanding Invoice Report By Category Group",
        to: "/outstanding-invoice-report-by-category-group",
      },
      {
        icon: "report",
        text: "Account Receivable Report",
        to: "/cash-receipt-listing-by-date",
      },
      {
        icon: "report",
        text: "Account Receivable Report By Customer",
        to: "/account-receivable-report-by-customer",
      },
      {
        icon: "report",
        text: "Damage Sale (Approved) Report",
        to: "/damage-sale-approved-report",
      },
      {
        icon: "report",
        text: "Damage Sale (Not Approved) Report",
        to: "/damage-sale-not-approved-report",
      },
      {
        icon: "report",
        text: "Account Receivable(Advanced Type) Report",
        to: "/account-receivable-advanced-type-report",
      },
      {
        icon: "report",
        text: "Sale Report By Category",
        to: "/sale-report-by-category",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report By Category Group",
        to: "/customer-product-sale-report-by-category-group",
      },
      {
        icon: "report",
        text: "Daily Customer Sale Report By Category Group",
        to: "/daily-customer-sale-report-by-category-group",
      },
      {
        icon: "report",
        text: "Customer Sale Analysis Report By Category Group",
        to: "/customer-sale-analysis-report-by-category-group",
      },
      {
        icon: "report",
        text: "Damage Sale (Approved) Report By Category Group",
        to: "/damage-sale-approved-report-by-category-group",
      },
      {
        icon: "report",
        text: "Damage Sale (Not Approved) Report By Category Group",
        to: "/damage-sale-not-approved-report-by-category-group",
      },
      {
        icon: "report",
        text: "Customer Sale Report by Sale Team",
        to: "/customer-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Customer Product Sale Report by Sale Team",
        to: "/customer-product-sale-report-by-sale-team",
      },
      {
        icon: "report",
        text: "Product Sale Report by Sale Team",
        to: "/product-sale-report-by-sale-team",
      },
    ],
  },

  {
    header: "Purchase Reports",
    subMenu: [
      {
        icon: "report",
        text: "Purchase Income Stock Report",
        to: "/po-stock-report",
      },
      {
        icon: "report",
        text: "Account Payable Report",
        to: "/account-payable-report",
      },
      {
        icon: "report",
        text: "Account Payable Report By Supplier",
        to: "/account-payable-report-by-supplier",
      },
      {
        icon: "report",
        text: "Stock Valuation Report",
        to: "/stock-valuation-report",
      },
      { icon: "report", text: "Stock Balance Report", to: "/stock-balances" },
      {
        icon: "report",
        text: "Stock Balance Summary Report",
        to: "/stock-balance-summary",
      },
      {
        icon: "report",
        text: "Stock Transfer Report",
        to: "/stock-transfer-report",
      },
      {
        icon: "report",
        text: "Purchase Order Report",
        to: "/purchase-order-report",
      },
      {
        icon: "report",
        text: "Purchase Analysis Report by Supplier",
        to: "/purchase-analysis-report",
      },
    ],
  },
];

export const AssetManagerMenus = [
  {
    header: "Warehouse Management",
    subMenu: [
      { icon: "photo_library", text: "Stock In", to: "/stockins" },
      { icon: "edit", text: "Stock Adjustment", to: "/stock-adjustments" },
      { icon: "redeem", text: "Stock Issue", to: "/stock-issues" },
      {
        icon: "account_balance_wallet",
        text: "Stock Ledger",
        to: "/stock-ledgers",
      },
      { icon: "photo_library", text: "Stock Take", to: "/stock-takes" },
      {
        icon: "import_export",
        text: "Location Movement",
        to: "/location-movements",
      },
      { icon: "report", text: "Stock Balance", to: "/stock-balances" },
    ],
  },
  {
    header: "Asset Management",
    subMenu: [
      {
        icon: "build",
        text: "Maintenance Frequency",
        to: "/maintenance-frequencys",
      },
      { icon: "build", text: "Maintenance Type", to: "/maintenance-types" },
      { icon: "build", text: "Machine Type", to: "/machine-types" },
      {
        icon: "build",
        text: "Check List Frequency",
        to: "/check-list-frequencys",
      },
      { icon: "account_balance_wallet", text: "Asset", to: "/assets" },
      { icon: "build", text: "Machine", to: "/machines" },
      {
        icon: "account_balance_wallet",
        text: "Check List",
        to: "/check-lists",
      },
      {
        icon: "account_balance_wallet",
        text: "Maintenance Schedule",
        to: "/maintenance-schedules",
      },
      {
        icon: "report",
        text: "Preventive Maintenance Machine Report",
        to: "/preventive-maintenance-machine-report",
      },
      {
        icon: "shopping_basket",
        text: "Purchase Order(Asset)",
        to: "/purchase-order-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan(Asset)",
        to: "/procurement-plan-assets",
      },
      {
        icon: "list",
        text: "Procurement Plan Report(Asset)",
        to: "/procurement-plan-asset-report",
      },
      {
        icon: "list",
        text: "Asset Summary Report",
        to: "/asset-summary-report",
      },
      { icon: "list", text: "Asset Detail Report", to: "/asset-detail-report" },
    ],
  },
];
